/**
 * Turns a URL into something safe to write to the console and to the QA log
 * artifacts: the path plus the query parameter *names*, never their values
 * (search text, email addresses, ...) and never the fragment.
 * e.g. `/search?query=jane%40example.com&page=2#top` -> `/search?query&page`
 */
export function toLogLabel(url: string): string {
  // The base is only there so relative URLs parse; it never reaches the output.
  const parsed = new URL(url, 'http://placeholder.invalid');
  const names = [...new Set(parsed.searchParams.keys())];

  return names.length
    ? `${parsed.pathname}?${names.join('&')}`
    : parsed.pathname;
}
